<template>
  <button
    class="tw-block tw-w-full tw-p-4 hover:tw-bg-blue hover:tw-bg-opacity-2 tw-bg-opacity-2 tw-flex tw-items-center tw-justify-center lg:tw-justify-start tw-outline-none"
    :class="isActive && `tw-bg-blue`"
  >
    <img :src="chat.image" alt="" class="tw-w-16 tw-h-16 tw-rounded-full lg:tw-mr-4">
    <div class="tw-hidden lg:tw-block">
      <div class="tw-text-left">
        <span>{{chat.title}}</span>
        <!--<span v-if="chat.unread_messages_count !== 0" class="tw-inline-block tw-px-2 tw-rounded-sm tw-bg-red tw-text-light tw-font-bold tw-text-lg tw-relative tw-bottom-2px">{{chat.unread_messages_count}}</span>-->
        <span v-if="!this.isActive && !chat.read_by.includes(this.user.id)" class="tw-inline-block tw-rounded-2xl tw-bg-red tw-w-4 tw-h-4 tw-relative tw-bottom-1"></span>
      </div>
      <div class="tw-text-gray-500 tw-text-lg">Last Message : {{chat.updated_at}}</div>
    </div>
  </button>
</template>
<script>
  export default {
    props: {
      user : {},
      chat: {},
      isActive: {},
    }
  }
</script>
